import { CurrentUser } from '@/data/users/CurrentUser';
import { useCurrentUserAvatar } from '@/hooks/api/profile/useCurrentUserAvatar';
import { ProfilePicture } from 'klayowebshared';

interface CurrentUserAvatarProps {
  user: CurrentUser | null | undefined;
  size: keyof typeof ProfilePicture.size;
  /** Upload POST in flight — shows the spinner (owned by the caller, not the fetch/poll). */
  updating?: boolean;
  sx?: object;
}

/**
 * Avatar for the SIGNED-IN user's own picture. Delegates fetch/poll/blob to useCurrentUserAvatar and
 * renders through the shared <ProfilePicture> (no visual fork) via its `imageUrl` override:
 * `imageUrl` = object URL when ready, else `null` (initials fallback for loading/processing/error).
 */
export function CurrentUserAvatar({ user, size, updating, sx }: CurrentUserAvatarProps) {
  const { imageUrl } = useCurrentUserAvatar(user);

  return (
    <ProfilePicture user={user} size={size} imageUrl={imageUrl} updating={updating} sx={sx} />
  );
}
